import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import { useAuth } from '../context/AuthContext';
import Comments from './comments/Comments';
import Header from './utils/Header';
import Footer from './utils/Footer';
import Searcher from './utils/Searcher';
import Salient from './salients/Salients';
import cupon from '../assets/Cupon.png';


const Home = () => {
  const { token, logout } = useAuth();

  useEffect(() => {
    // Swal.fire({
    //   title: '¡Reserva y recibe un 5% de descuento en estadía!',
    //   html: `<div style="display: flex; flex-direction: column; align-items: center;">
    //            <img src="${cupon}" alt="Icono de descuento" style="width: 100px; margin-bottom: 15px;" />
    //          </div>`,
    //   icon: undefined,
    //   showConfirmButton: true,
    //   confirmButtonText: 'Aceptar',
    //   backdrop: true,
    //   customClass: {
    //       confirmButton: "bg-[#1F4F51] hover:bg-[#17403F] text-white font-semibold py-2 px-6 rounded-md w-40",
    //     popup: 'rounded-2xl',
    //   },
    // });
  }, []);

  return (
    <div className="relative"> {/* Evita problemas de posicionamiento */}
      <Header />
      <Searcher />
      <Salient />
      <Comments />
      <Footer/>
    </div>
  );
};

export default Home;
